// extracted by mini-css-extract-plugin
export default {"text":"HintOpenBrowser_text__8J+2O"};